module.exports = __webpack_public_path__ + "img/w8-cover.f5614d1b.jpg";